import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

/**
 * Mount once at the App level. Fires a /api/stats/pageview ping on every
 * route change. No cookies, no PII — backend only stores route + bucketed
 * referrer + UA class.
 */
export const usePageviewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // Skip founder & internal routes to avoid skewing the data
    if (location.pathname.startsWith("/founder") || location.pathname.startsWith("/api")) return;

    const payload = {
      path: location.pathname,
      referrer: document.referrer || "",
    };
    // Fire-and-forget — never block UI on this
    axios.post(`${API}/stats/pageview`, payload).catch(() => {});
  }, [location.pathname]);
};

/** Drop-in component variant for App.js. */
export const PageviewTracker = () => {
  usePageviewTracker();
  return null;
};
